// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: 1e0B3Xwp-A
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import MainPaymentsCta from "../../MainPaymentsCta"; // plasmic-import: UFDEOqO0nC/component
import Card from "../../Card"; // plasmic-import: Gc-TRbS8XX/component
import Wire from "../../Wire"; // plasmic-import: v5d6gts_S6/component
import Crypto from "../../Crypto"; // plasmic-import: VnGgrE4c19/component
import PaymentsPageSidebar from "../../PaymentsPageSidebar"; // plasmic-import: FaRlVP157fG/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicPaymentsPage.module.css"; // plasmic-import: 1e0B3Xwp-A/css
import Line2Icon from "./icons/PlasmicIcon__Line2"; // plasmic-import: InwQcdozxk/icon
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: t-tWHZTgfh/icon

createPlasmicElementProxy;

export const PlasmicPaymentsPage__VariantProps = new Array();

export const PlasmicPaymentsPage__ArgProps = new Array();

const $$ = {};

function PlasmicPaymentsPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__pKqn)}>
            <div
              data-plasmic-name={"companyName"}
              data-plasmic-override={overrides.companyName}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.companyName
              )}
            >
              {"Vayner Media"}
            </div>
            <div
              data-plasmic-name={"rectangle29"}
              data-plasmic-override={overrides.rectangle29}
              className={classNames(projectcss.all, sty.rectangle29)}
            >
              <div
                data-plasmic-name={"figmaPaste"}
                data-plasmic-override={overrides.figmaPaste}
                className={classNames(projectcss.all, sty.figmaPaste)}
              >
                <div
                  data-plasmic-name={"requestedEscrowDesposit30000"}
                  data-plasmic-override={overrides.requestedEscrowDesposit30000}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.requestedEscrowDesposit30000
                  )}
                >
                  {"Requested Escrow Desposit: $900.00\n"}
                </div>
                <div
                  data-plasmic-name={"milestone1InitialSetup"}
                  data-plasmic-override={overrides.milestone1InitialSetup}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.milestone1InitialSetup
                  )}
                >
                  {"Milestone 1: Initial Setup\n\n"}
                </div>
                <Line2Icon
                  className={classNames(projectcss.all, sty.svg__za5Iu)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"viewDetails"}
                  data-plasmic-override={overrides.viewDetails}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.viewDetails
                  )}
                >
                  {"View Full Contract Details  >"}
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"rectangle28"}
              data-plasmic-override={overrides.rectangle28}
              className={classNames(projectcss.all, sty.rectangle28)}
            >
              <div
                data-plasmic-name={"figmaPaste2"}
                data-plasmic-override={overrides.figmaPaste2}
                className={classNames(projectcss.all, sty.figmaPaste2)}
              >
                <MainPaymentsCta
                  data-plasmic-name={"mainPaymentsCta"}
                  data-plasmic-override={overrides.mainPaymentsCta}
                  className={classNames("__wab_instance", sty.mainPaymentsCta)}
                />

                <Line1Icon
                  className={classNames(projectcss.all, sty.svg__mZaA)}
                  role={"img"}
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__b9BhR
                  )}
                >
                  {"Or fund the escrow a different way"}
                </div>
                <Card
                  data-plasmic-name={"card"}
                  data-plasmic-override={overrides.card}
                  className={classNames("__wab_instance", sty.card)}
                />

                <Wire
                  data-plasmic-name={"wire"}
                  data-plasmic-override={overrides.wire}
                  className={classNames("__wab_instance", sty.wire)}
                />

                <Crypto
                  data-plasmic-name={"crypto"}
                  data-plasmic-override={overrides.crypto}
                  className={classNames("__wab_instance", sty.crypto)}
                />

                <div
                  className={classNames(projectcss.all, sty.freeBox__qqxBx)}
                />
              </div>
            </div>
            <div
              data-plasmic-name={"figmaPaste3"}
              data-plasmic-override={overrides.figmaPaste3}
              className={classNames(projectcss.all, sty.figmaPaste3)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__oTemQ
                )}
              >
                {"Powered by astrius"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___96QUm
                )}
              >
                {
                  "Your funds will be safeguarded until Vayner Media has delivered their service according to the contract terms."
                }
              </div>
            </div>
          </div>
          <PaymentsPageSidebar
            data-plasmic-name={"paymentsSideBar"}
            data-plasmic-override={overrides.paymentsSideBar}
            className={classNames("__wab_instance", sty.paymentsSideBar)}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "requestedEscrowDesposit30000",
    "milestone1InitialSetup",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "mainPaymentsCta",
    "card",
    "wire",
    "crypto",
    "figmaPaste3",
    "paymentsSideBar"
  ],

  companyName: ["companyName"],
  rectangle29: [
    "rectangle29",
    "figmaPaste",
    "requestedEscrowDesposit30000",
    "milestone1InitialSetup",
    "viewDetails"
  ],

  figmaPaste: [
    "figmaPaste",
    "requestedEscrowDesposit30000",
    "milestone1InitialSetup",
    "viewDetails"
  ],

  requestedEscrowDesposit30000: ["requestedEscrowDesposit30000"],
  milestone1InitialSetup: ["milestone1InitialSetup"],
  viewDetails: ["viewDetails"],
  rectangle28: [
    "rectangle28",
    "figmaPaste2",
    "mainPaymentsCta",
    "card",
    "wire",
    "crypto"
  ],

  figmaPaste2: ["figmaPaste2", "mainPaymentsCta", "card", "wire", "crypto"],
  mainPaymentsCta: ["mainPaymentsCta"],
  card: ["card"],
  wire: ["wire"],
  crypto: ["crypto"],
  figmaPaste3: ["figmaPaste3"],
  paymentsSideBar: ["paymentsSideBar"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaymentsPage__ArgProps,
          internalVariantPropNames: PlasmicPaymentsPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaymentsPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentsPage";
  } else {
    func.displayName = `PlasmicPaymentsPage.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentsPage = Object.assign(
  // Top-level PlasmicPaymentsPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    companyName: makeNodeComponent("companyName"),
    rectangle29: makeNodeComponent("rectangle29"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    requestedEscrowDesposit30000: makeNodeComponent(
      "requestedEscrowDesposit30000"
    ),
    milestone1InitialSetup: makeNodeComponent("milestone1InitialSetup"),
    viewDetails: makeNodeComponent("viewDetails"),
    rectangle28: makeNodeComponent("rectangle28"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    mainPaymentsCta: makeNodeComponent("mainPaymentsCta"),
    card: makeNodeComponent("card"),
    wire: makeNodeComponent("wire"),
    crypto: makeNodeComponent("crypto"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    paymentsSideBar: makeNodeComponent("paymentsSideBar"),
    // Metadata about props expected for PlasmicPaymentsPage
    internalVariantProps: PlasmicPaymentsPage__VariantProps,
    internalArgProps: PlasmicPaymentsPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicPaymentsPage;
/* prettier-ignore-end */
